// extracted by mini-css-extract-plugin
module.exports = {"content":"LeaveReview_content__2Nomr"};